const iconMap = {
    // 保证 jobTypeColors[String(v.jobTypeCode)] 中取不到 jobTypeCode 时页面不报错
    'null': {
      jobIcon: null,
      jobIconActive: null,
      vehicleOnline: null,
      vehicleNotOnline: null,
      echartsJobFill: 'rgba(128, 128, 128, 1)',
      echartsJobLight: 'rgba(128, 128, 128, 0.3)',
      echartsLineJobLight: 'rgba(128, 128, 128, 0.6)',
    },
    // 全部
    'default': {
        jobIcon: require('@/assets/images/jobIcon/menu_icon_all.png'),
        jobIconActive: require('@/assets/images/jobIcon/menu_icon_all_a.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_car.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_car_c.png'),
        echartsJobFill: 'rgba(219, 255, 76, 1)',
        echartsJobLight: 'rgba(219, 255, 76, 0.3)',
        echartsLineJobLight: 'rgba(219, 255, 76, 0.6)',
    },
    // 谷物收获作业
    // 播种类作业（大类）
    '1001': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_bzl.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_bzl_c.png'),
        // vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_bzl.png'),
        // vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_bzl_c.png'),
        echartsJobFill: 'rgba(237, 0, 71, 1)',
        echartsJobLight: 'rgba(237, 0, 71, 0.3)',
        echartsLineJobLight: 'rgba(237, 0, 71, 0.6)',
    },
    // 插秧类作业（大类）
    '1002': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_cyl.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_cyl_c.png'),
        // vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_bzl.png'),
        // vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_bzl_c.png'),
        echartsJobFill: 'rgba(207, 103, 0, 1)',
        echartsJobLight: 'rgba(207, 103, 0, 0.3)',
        echartsLineJobLight: 'rgba(207, 103, 0, 0.6)',
    },
    // 耕整类作业（大类）
    '1003': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_gzljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_gzljx_c.png'),
        // vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx.png'),
        // vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx_c.png'),
        echartsJobFill: 'rgba(255, 153, 0, 1)',
        echartsJobLight: 'rgba(255, 153, 0, .3)',
        echartsLineJobLight: 'rgba(255, 153, 0, .6)',
    },
    // 收货类作业（大类）
    '1004': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_shljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_shljx_c.png'),
        // vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_shljx.png'),
        // vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_shljx_c.png'),
        echartsJobFill: 'rgba(255, 229, 0, 1)',
        echartsJobLight: 'rgba(255, 229, 0, 0.3)',
        echartsLineJobLight: 'rgba(255, 229, 0, 0.6)',
    },
    // 植保类作业（大类）
    '1005': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_zbl.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_zbl_c.png'),
        // vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_zbl.png'),
        // vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_zbl_c.png'),
        echartsJobFill: 'rgba(237, 36, 0, 1)',
        echartsJobLight: 'rgba(237, 36, 0, 0.3)',
        echartsLineJobLight: 'rgba(237, 36, 0, 0.6)',
    },
   '32': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_gwsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_gwsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_gwsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_gwsh_c.png'),
        echartsJobFill: 'rgba(161, 107, 255, 1)',
        echartsJobLight: 'rgba(161, 107, 255, 0.3)',
        echartsLineJobLight: 'rgba(161, 107, 255, 0.6)',
    },
    // 喷杆式植保
   '10': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_pgzb.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_pgzb_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_pgzb.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_pgzb_c.png'),
        echartsJobFill: 'rgba(255, 130, 108, 1)',
        echartsJobLight: 'rgba(255, 130, 108, 0.3)',
        echartsLineJobLight: 'rgba(255, 130, 108, 0.6)',
    },
    // 烘干（循环式）
   '71': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_hgt.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_hgt_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_hgt.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_hgt_c.png'),
        echartsJobFill: 'rgba(255, 130, 76, 1)',
        echartsJobLight: 'rgba(255, 130, 76, 0.3)',
        echartsLineJobLight: 'rgba(255, 130, 76, 0.6)',
    },
    // 菌类装袋
   '81': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_jlzd.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_jlzd_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_jlzd.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_jlzd_c.png'),
        echartsJobFill: 'rgba(255, 184, 76, 1)',
        echartsJobLight: 'rgba(255, 184, 76, 0.3)',
        echartsLineJobLight: 'rgba(255, 184, 76, 0.6)',
    },
    // 无人机植保
   '51': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_wrzb.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_wrzb_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_wrzb.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_wrzb_c.png'),
        echartsJobFill: 'rgba(255, 107, 196, 1)',
        echartsJobLight: 'rgba(255, 107, 196, 0.3)',
        echartsLineJobLight: 'rgba(255, 107, 196, 0.6)',
    },
    // 秸秆打捆
   '8': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_jgdk.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_jgdk_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_jgdk.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_jgdk_c.png'),
        echartsJobFill: 'rgba(235, 255, 153, 1)',
        echartsJobLight: 'rgba(235, 255, 153, 0.3)',
        echartsLineJobLight: 'rgba(235, 255, 153, 0.6)',
    },
    // 小麦免耕播种
   '4': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_xmmg.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_xmmg_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_xmmg.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_xmmg_c.png'),
        echartsJobFill: 'rgba(255, 245, 153, 1)',
        echartsJobLight: 'rgba(235, 255, 153, 0.3)',
        echartsLineJobLight: 'rgba(235, 255, 153, 0.6)',
    },
    // 花生捡拾收获
   '37': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_hsjssh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_hsjssh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_hsjssh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_hsjssh_c.png'),
        echartsJobFill: 'rgba(250, 107, 255, 1)',
        echartsJobLight: 'rgba(250, 107, 255, 0.3)',
        echartsLineJobLight: 'rgba(250, 107, 255, 0.6)',
    },
    // 旋耕
   '13': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_xg.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_xg_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_xg.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_xg_c.png'),
        echartsJobFill: 'rgba(255, 218, 107, 1)',
        echartsJobLight: 'rgba(255, 218, 107, 0.3)',
        echartsLineJobLight: 'rgba(255, 218, 107, 0.6)',
    },
    // 旋耕（带深度）
   '108': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_xg.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_xg_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_xg.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_xg_c.png'),
        echartsJobFill: 'rgba(255, 153, 245, 1)',
        echartsJobLight: 'rgba(255, 153, 245, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 245, 0.6)',
    },
    // 小麦收获作业
   '5': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_xmsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_xmsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_xmsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_xmsh_c.png'),
        echartsJobFill: 'rgba(248, 255, 107, 1)',
        echartsJobLight: 'rgba(248, 255, 107, 0.3)',
        echartsLineJobLight: 'rgba(248, 255, 107, 0.6)',
    },
    // 小麦收获作业+收获类定位终端
   '188': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_shljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_shljx_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_shljx.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_shljx_c.png'),
        echartsJobFill: 'rgba(255, 229, 0, 1)',
        echartsJobLight: 'rgba(255, 229, 0, 0.3)',
        echartsLineJobLight: 'rgba(255, 229, 0, 0.6)',
    },
        // 耕整类
   '199': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_gzljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_gzljx_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx_c.png'),
        echartsJobFill: 'rgba(255, 153, 0, 1)',
        echartsJobLight: 'rgba(255, 153, 0, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 0, 0.6)',
    },
    // 深松作业
   '1': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ss.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ss_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ss.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ss_c.png'),
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
    },
    // 玉米收获作业
   '6': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ymsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ymsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ymsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ymsh_c.png'),
        echartsJobFill: 'rgba(255, 153, 214, 1)',
        echartsJobLight: 'rgba(255, 153, 214, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 214, 0.6)',
    },
    // 种猪自动饲喂
   '101': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_zzsw.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_zzsw_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_zzsw.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_zzsw_c.png'),
        echartsJobFill: 'rgba(255, 121, 64, 1)',
        echartsJobLight: 'rgba(255, 121, 64, 0.3)',
        echartsLineJobLight: 'rgba(255, 121, 64, 0.6)',
    },
    // 智能灌溉
   '100': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_zngg.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_zngg_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_zngg.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_zngg_c.png'),
        echartsJobFill: 'rgba(245, 255, 64, 1)',
        echartsJobLight: 'rgba(245, 255, 64, 0.3)',
        echartsLineJobLight: 'rgba(245, 255, 64, 0.6)',
    },
    // 鱼塘增氧
   '102': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ytzy.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ytzy_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ytzy.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ytzy_c.png'),
        echartsJobFill: 'rgba(255, 237, 76, 1)',
        echartsJobLight: 'rgba(255, 237, 76, 0.3)',
        echartsLineJobLight: 'rgba(255, 237, 76, 0.6)',
    },
    // 耕整类机械
   '01': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_gzljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_gzljx_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_gzljx_c.png'),
        echartsJobFill: 'rgba(255, 153, 0, 1)',
        echartsJobLight: 'rgba(255, 153, 0, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 0, 0.6)',
    },
    // 收获类机械
   '04': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_shljx.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_shljx_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_shljx.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_shljx_c.png'),
        echartsJobFill: 'rgba(255, 229, 0, 1)',
        echartsJobLight: 'rgba(255, 229, 0, 0.3)',
        echartsLineJobLight: 'rgba(255, 229, 0, 0.6)',
    },
    // 辣椒收获
   '63': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ljsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ljsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ljsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ljsh_c.png'),
        echartsJobFill: 'rgba(235, 153, 255, 1)',
        echartsJobLight: 'rgba(235, 153, 255, 0.3)',
        echartsLineJobLight: 'rgba(235, 153, 255, 0.6)',
    },
    // 辣椒施肥旋耕
   '62': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ljsf.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ljsf_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ljsf.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ljsf_c.png'),
        echartsJobFill: 'rgba(204, 153, 255, 1)',
        echartsJobLight: 'rgba(204, 153, 255, 0.3)',
        echartsLineJobLight: 'rgba(204, 153, 255, 0.6)',
    },
    // 辣椒铺管覆膜直播
   '61': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ljpgfm.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ljpgfm_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ljpgfm.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ljpgfm_c.png'),
        echartsJobFill: 'rgba(173, 153, 255, 1)',
        echartsJobLight: 'rgba(173, 153, 255, 0.3)',
        echartsLineJobLight: 'rgba(173, 153, 255, 0.6)',
    },
    // 辣椒初加工
   '64': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ljcjg.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ljcjg_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ljcjg.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ljcjg_c.png'),
        echartsJobFill: 'rgba(219, 255, 76, 1)',
        echartsJobLight: 'rgba(219, 255, 76, 0.3)',
        echartsLineJobLight: 'rgba(219, 255, 76, 0.6)',
    },
    // 秸秆粉碎还田
   '2': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_jght.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_jght_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_jght.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_jght_c.png'),
        echartsJobFill: 'rgba(255, 184, 153, 1)',
        echartsJobLight: 'rgba(255, 184, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 184, 153, 0.6)',
    },
    // 花生挖掘收获
   '53': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_hssh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_hssh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_hssh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_hssh_c.png'),
        echartsJobFill: 'rgba(219, 255, 76, 1)',
        echartsJobLight: 'rgba(219, 255, 76, 0.3)',
        echartsLineJobLight: 'rgba(219, 255, 76, 0.6)',
    },
    // 水稻收获
   '36': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_sdsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_sdsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_sdsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_sdsh_c.png'),
        echartsJobFill: 'rgba(206, 107, 255, 1)',
        echartsJobLight: 'rgba(206, 107, 255, 0.3)',
        echartsLineJobLight: 'rgba(206, 107, 255, 0.6)',
    },
    // 水稻插秧
   '11': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_sdcy.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_sdcy_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_sdcy.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_sdcy_c.png'),
        echartsJobFill: 'rgba(255, 174, 107, 1)',
        echartsJobLight: 'rgba(255, 174, 107, 0.3)',
        echartsLineJobLight: 'rgba(255, 174, 107, 0.6)',
    },
    // 玉米播种作业
   '7': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ymbz.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ymbz_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ymbz.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ymbz_c.png'),
        echartsJobFill: 'rgba(255, 107, 151, 1)',
        echartsJobLight: 'rgba(255, 107, 151, 0.3)',
        echartsLineJobLight: 'rgba(255, 107, 151, 0.6)',
    },
    // 深翻作业
   '3': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_sf.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_sf_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_sf.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_sf_c.png'),
        echartsJobFill: 'rgba(255, 214, 153, 1)',
        echartsJobLight: 'rgba(255, 214, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 214, 153, 0.6)',
    },
    // 大豆收获作业
   '38': {
        jobIcon: require('@/assets/images/jobIcon/btn_menu_ddsh.png'),
        jobIconActive: require('@/assets/images/jobIcon/btn_menu_ddsh_c.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_ddsh.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_ddsh_c.png'),
        echartsJobFill: 'rgba(255, 107, 240, 1)',
        echartsJobLight: 'rgba(255, 107, 240, 0.3)',
        echartsLineJobLight: 'rgba(255, 107, 240, 0.6)',
    },
    // 其它收获作业
   '999': {
        jobIcon: require('@/assets/images/jobIcon/menu_icon_all.png'),
        jobIconActive: require('@/assets/images/jobIcon/menu_icon_all_a.png'),
        vehicleOnline: require('@/assets/images/vehicleIcon/icon_map_car.png'),
        vehicleNotOnline: require('@/assets/images/vehicleIcon/icon_map_car_c.png'),
        echartsJobFill: 'rgba(219, 255, 76, 1)',
        echartsJobLight: 'rgba(219, 255, 76, 0.3)',
        echartsLineJobLight: 'rgba(219, 255, 76, 0.6)',
    },
}
export default iconMap
